import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../../../features/auth/axiosConfig";

export const useCarPayment = (id: string | null) => {
  const navigate = useNavigate();

  const updatePayment = useCallback(
    async (paymentMethod: string) => {
      if (!id) return;

      try {
        const update = { payment: { paymentMethod } };
        const response = await api.put(`/app/pos/v2/customer/${id}`, update);

        if (response.data && id) {
          navigate(`/v1/car-payment-cash?id=${id}`);
        } else {
          console.error("Error: Missing '_id' in API response");
        }
      } catch (error) {
        console.error("Error updating car details:", error);
      }
    },
    [id, navigate]
  );

  return { updatePayment };
};
